/**
 * Below this width the chat/wizard split leaves neither pane a usable width,
 * so the layout collapses to a single visible pane with a toggle on each edge.
 */
export const NARROW_LAYOUT_QUERY = '(max-width: 1024px)';

/** Chat pane width bounds while dragging the split handle, in percent of the body. */
export const CHAT_PANE_MIN_WIDTH = 15;
export const CHAT_PANE_MAX_WIDTH = 35;

/**
 * Dragging the handle past either bound means the user wants a single pane, not a wider split,
 * so the pane being squeezed out collapses to its edge pill instead of the drag stopping at the bound.
 */
export const CHAT_PANE_HIDE_FIELDS_THRESHOLD = 45;
export const CHAT_PANE_HIDE_CHAT_THRESHOLD = 5;

export const DEFAULT_RESPONSE_TEMPLATE = `{% set d = (data.d if data is mapping and data.d is defined else None) %}
      {
        "ok": {{ (status >= 200 and status < 300) | tojson }},
        {% if status >= 200 and status < 300 %}
        "message": "Success",
        "status": {{ (status | default('call success')) | tojson }},
        "parameters": {{ (d if d else data | default({})) | tojson }}
        {% else %}
        "message": "Error",
        "status": {{ (status | default('unknown')) | tojson }},
        "error": {{ (data.error if data is mapping and data.error is defined else 'Unknown error') | tojson }},
        "parameters": {{ (d if d else data | default({})) | tojson }}
        {% endif %}
      }`;
